<template>
  <DxDropDownButton
    :items="locales"
    :drop-down-options="{ width: 75 }"
    :text="localization.localeGet().toUpperCase()"
    :showArrowIcon="false"
    @item-click="changeLocale"
    stylingMode="text"
  />
</template>

<script setup>
import { themeService } from '../theme-service';
import DxDropDownButton from 'devextreme-vue/drop-down-button';

const currentTheme = themeService.currentTheme;

const locales = [
  'LV',
  'EN',
  'RU',
];
import { useLocalization } from "@/locales/localization";
const localization = useLocalization();

function changeLocale(e) {
  localization.localeChange(e.itemData.toLowerCase());
}
</script>

<style>
.dx-widget.dx-button.dx-button-mode-text.dx-button-normal.dx-dropdownbutton-action {
    background-color: transparent;
}
</style>